export default "__VITE_ASSET__vWFXVYin__"